/* eslint-disable react/prop-types */
import React from 'react';
import { LazyQMASDocumentModal } from 'components/Molecules/Upload/QMASDocument/index';
import cn from 'classnames';
import classes from './QmasDocumentCell.module.scss';

const QmasDocumentModalCell = ({ documents, wrapClassName, onSubmit, triggerElement }) => {
  const qmasDocumentRef = React.createRef();
  const closeModalRef = React.createRef(null);
  const [readonly, setReadonly] = React.useState(true);

  return (
    <LazyQMASDocumentModal
      destroyOnClose
      title="Document Detail"
      width={1100}
      okText="Confirm"
      documents={documents}
      childRef={qmasDocumentRef}
      readonly={readonly}
      afterReadonlyChange={(isReadonly) => {
        setReadonly(isReadonly);
      }}
      wrapClassName={cn(classes.overlayModal, wrapClassName)}
      triggerElement={triggerElement}
      onCancel={(closeModal) => {
        setReadonly(true);
        closeModal();
      }}
      onOk={(closeModal) => {
        closeModalRef.current = closeModal;
        if (qmasDocumentRef.current) {
          qmasDocumentRef.current.submit();
        }
      }}
      featureFlags={['saveTo', 'reminder', 'compliance-data']}
      relatedSource={{}}
      footer={readonly ? null : undefined}
      onSubmit={(values, form, stateReadOnly) => {
        if (!stateReadOnly) {
          onSubmit(values, form, stateReadOnly, () => {
            closeModalRef.current();
            setReadonly(true);
          });
        }
      }}
    />
  );
};

export default QmasDocumentModalCell;
